<template>
  <div class="review-page">
    <div class="banner-top">
      <div class="banner-box">转账订单审核</div>
    </div>
    <div class="review-box" v-if="isAdmin">
      <div class="filter-bar">
        <el-radio-group v-model="statusFilter" @change="loadOrders" size="small">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button label="1">待审核</el-radio-button>
          <el-radio-button label="2">已开通</el-radio-button>
          <el-radio-button label="3">已关闭</el-radio-button>
        </el-radio-group>
        <el-button size="small" icon="el-icon-download" @click="exportExcel" style="margin-left: 20px;">导出Excel</el-button>
      </div>

      <el-table :data="orders" style="width: 100%" v-loading="loading" border>
        <el-table-column prop="order_id" label="订单编号" width="220"></el-table-column>
        <el-table-column prop="username" label="用户名" width="140"></el-table-column>
        <el-table-column prop="user_realname" label="姓名" width="100"></el-table-column>
        <el-table-column prop="wechat" label="微信名" width="120"></el-table-column>
        <el-table-column prop="phone" label="手机号" width="140"></el-table-column>
        <el-table-column prop="package_name" label="套餐" width="120"></el-table-column>
        <el-table-column prop="amount" label="金额" width="100">
          <template slot-scope="scope">
            <span style="color: #d4380d; font-weight: 700;">￥{{ scope.row.amount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="pay_method" label="支付方式" width="100">
          <template slot-scope="scope">
            {{ scope.row.pay_method === 'online' ? '在线支付' : '银行转账' }}
          </template>
        </el-table-column>
        <el-table-column prop="status_text" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="statusTagType(scope.row.status)" size="small">{{ scope.row.status_text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="下单时间" width="170"></el-table-column>
        <el-table-column prop="expire_time" label="到期时间" width="170">
          <template slot-scope="scope">
            {{ scope.row.expire_time || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <template v-if="scope.row.status === 0 || scope.row.status === 1">
              <el-button size="mini" type="success" @click="confirmOrder(scope.row, 'open')" :loading="scope.row._loading">确认开通</el-button>
              <el-button size="mini" type="danger" @click="confirmOrder(scope.row, 'reject')">关闭</el-button>
            </template>
            <span v-else style="color: #999; font-size: 13px;">{{ scope.row.status === 2 ? '已开通' : scope.row.status === 3 ? '已关闭' : '-' }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="no-auth" v-else>
      <i class="el-icon-warning-outline" style="font-size: 48px; color: #e6a23c;"></i>
      <p>无权访问此页面</p>
    </div>
  </div>
</template>

<script>
import { orderList } from "@/api/order";
import request from "@/utils/request";

export default {
  name: "TransferReview",
  data() {
    return {
      isAdmin: false,
      orders: [],
      loading: false,
      statusFilter: '1',
    }
  },
  created() {
    this.$emit('header', true);
    this.$emit('footer', true);
    const username = window.localStorage.getItem('username');
    if (username === 'duanjiaheng') {
      this.isAdmin = true;
      this.loadOrders();
    }
  },
  methods: {
    loadOrders() {
      this.loading = true;
      orderList({status: this.statusFilter, all: 1}).then((res) => {
        this.loading = false;
        if (res && (res.code === 2000 || res.code === 200) && res.data) {
          this.orders = res.data.map(item => ({...item, _loading: false}));
        } else {
          this.orders = [];
        }
      }).catch(() => {
        this.loading = false;
        this.orders = [];
      });
    },
    confirmOrder(row, action) {
      const actionText = action === 'open' ? '确认开通' : '关闭订单';
      this.$confirm('确定要' + actionText + '（' + row.order_id + '）吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (action === 'open') {
          row._loading = true;
          this.$set(row, '_loading', true);
        }
        request({
          url: '/bolan/transfer/confirm/',
          method: 'post',
          data: {
            order_id: row.order_id,
            action: action,
          },
        }).then((res) => {
          if (row._loading) {
            row._loading = false;
            this.$set(row, '_loading', false);
          }
          if (res && (res.code === 2000 || res.code === 200)) {
            this.$message.success({message: res.msg || actionText + '成功', duration: 2000, offset: 400});
            this.loadOrders();
          } else {
            this.$message.error({message: (res && res.data) || actionText + '失败', duration: 2000, offset: 400});
          }
        }).catch((err) => {
          row._loading = false;
          this.$set(row, '_loading', false);
          this.$message.error({message: actionText + '失败', duration: 2000, offset: 400});
        });
      }).catch(() => {});
    },
    statusTagType(status) {
      if (status === 0) return 'info';
      if (status === 1) return 'warning';
      if (status === 2) return 'success';
      if (status === 3) return 'danger';
      return 'info';
    },
    exportExcel() {
      if (!this.orders || this.orders.length === 0) {
        this.$message.warning({message: '没有数据可导出', duration: 2000, offset: 400});
        return;
      }
      const headers = ['订单编号', '用户名', '姓名', '微信名', '手机号', '套餐', '金额', '支付方式', '状态', '下单时间', '到期时间'];
      const rows = this.orders.map(item => [
        item.order_id,
        item.username || '',
        item.user_realname || '',
        item.wechat || '',
        item.phone || '',
        item.package_name,
        '￥' + item.amount,
        item.pay_method === 'online' ? '在线支付' : '银行转账',
        item.status_text,
        item.create_time,
        item.expire_time || '-',
      ]);
      // BOM + CSV内容
      let csv = '\uFEFF' + headers.join(',') + '\n';
      rows.forEach(row => {
        csv += row.map(cell => '"' + String(cell).replace(/"/g, '""') + '"').join(',') + '\n';
      });
      const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = '订单列表_' + new Date().toISOString().slice(0, 10) + '.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
  }
}
</script>

<style scoped>
.banner-top {
  width: 100%;
  height: 100px;
  margin-top: 50px;
  background: url("../assets/images/banner_top.png") no-repeat center / cover;
  text-align: center;
  color: #fff;
}
.banner-box {
  font-size: 30px;
  font-weight: 600;
  line-height: 100px;
}
.review-box {
  width: 1200px;
  margin: 20px auto 40px;
}
.filter-bar {
  margin-bottom: 16px;
}
.no-auth {
  text-align: center;
  padding: 100px 0;
  color: #999;
  font-size: 16px;
}
.no-auth p {
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/TransferReview.vue